import type { ColTypeDef } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';

const UPFRONT_FEE_EDITOR_VALUES = [true, false] as const;

export function useUpfrontFeeColumnType<T>(yesNoColumnType: ColTypeDef<T>): ColTypeDef<T> {
  const { formatMessage } = useSPIntl();

  return useMemo<ColTypeDef<T>>(
    () => ({
      ...yesNoColumnType,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        multiSelect: false,
        allowTyping: false,
        filterList: false,
        highlightMatch: false,
        values: UPFRONT_FEE_EDITOR_VALUES,
        formatValue: (value: boolean | null | undefined) => formatMessage({ id: value ? 'yes' : 'no' }, undefined, {}),
      },
      keyCreator: ({ value }: { value: boolean | null | undefined }) => String(value ?? false),
    }),
    [formatMessage, yesNoColumnType],
  );
}
